export const copyClipBoard = async (text: string, onSuccess: () => void, onFailure: () => void) => {
  try {
    await navigator.clipboard.writeText(text)
    onSuccess()
  } catch (error) {
    console.error(error)
    onFailure()
  }
}
